import { useNavigate } from "react-router-dom";
import KaliaLogo from "../../assets/logo.svg";
import SmallLogo from "../../assets/logo-small-orange-square.svg";

interface Props {
    collapsed?: boolean;
    type?: "light" | "dark";
}

function Logo({ collapsed }: Props) {
    const navigate = useNavigate();

    return (
        <div
            className={`flex-1 flex items-center justify-center text-center`}
            style={{
                width: collapsed ? '32px' : '100%',
                padding: collapsed ? '4px' : '20px',
            }}
        >
            <img
                src={collapsed ? SmallLogo : KaliaLogo}
                alt="Kalia Lab"
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
                className={`${collapsed ? "w-6 mx-auto" : "w-36"}`}
            />
        </div>
    );
}

export default Logo;
